module.exports = __webpack_public_path__ + "static/abstract_2-6ca1cb5c7a183d060cb38cd9f2196de8.jpg";